var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'direction-right': _vm.isRight, 'color-dark': _vm.isDark}, 'voice']},[_c('IconBase',{staticClass:"voice_icon",attrs:{"width":20}},[_c('Voice')],1),_vm._m(0),_c('div',{staticClass:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v(" 先輩"),_c('br'),_vm._v("社員の声 ")])
}]

export { render, staticRenderFns }